$(document).ready(function () {

  $(".quick-view-collection").on("click", function (e) {
    e.preventDefault();
    var $btn = $(this);
    $btn.addClass("loading");
    $btn.closest(".card-wrapper").find(".quick-add__submit").trigger("click");
    setTimeout(function () {
      $btn.removeClass("loading");
    }, 2000);
  });
});

// $(document).ready(function () {
//   // Initially hide all lists on mobile
//   if ($(window).width() <= 749) {
//     $('.footer-according').hide();
//   }

//   $('.footer-block__heading').click(function () {
//     // Run toggle only on mobile
//     if ($(window).width() > 749) return;

//     const $heading = $(this);
//     const $parentBlock = $heading.closest('.footer-block');
//     const $details = $parentBlock.find('.footer-according');
//     const $showHide = $heading.find('.show-hide');
//     const $plusIcon = $showHide.find('.icon-plus');
//     const $minusIcon = $showHide.find('.icon-minus');

//     const isActive = $heading.hasClass('active');

//     // Reset all
//     $('.footer-block__heading').removeClass('active');
//     $('.footer-according').slideUp(200);
//     $('.icon-plus').removeClass('hidden');
//     $('.icon-minus').addClass('hidden');

//     // Activate clicked item
//     if (!isActive) {
//       $heading.addClass('active');
//       $details.stop().slideDown(200);
//       $plusIcon.addClass('hidden');
//       $minusIcon.removeClass('hidden');
//     }
//   });

//   // Optional: Reapply logic on window resize
//   $(window).resize(function () {
//     if ($(window).width() > 749) {
//       // Reset state for desktop
//       $('.footer-according').show();
//       $('.footer-block__heading').removeClass('active');
//       $('.icon-plus').addClass('hidden');
//       $('.icon-minus').removeClass('hidden');
//     } else {
//       // Reset to mobile state
//       $('.footer-according').hide();
//       $('.footer-block__heading').removeClass('active');
//       $('.icon-plus').removeClass('hidden');
//       $('.icon-minus').addClass('hidden');
//     }
//   });
// });


$(document).ready(function () {
  function setFooterState() {
    if ($(window).width() <= 749) {
      // Mobile: hide all sections, reset icons
      $('.footer-according').hide();
      $('.footer-block__heading').removeClass('active');
      $('.maryn-footer-section .icon-plus').removeClass('hidden');
      $('.maryn-footer-section .icon-minus').addClass('hidden');

      // Bind click for accordion
      $('.footer-block__heading').off('click.footerAccordion').on('click.footerAccordion', function () {
        const $heading = $(this);
        const $parentBlock = $heading.closest('.footer-block');
        const $details = $parentBlock.find('.footer-according');
        const $plusIcon = $heading.find('.icon-plus');
        const $minusIcon = $heading.find('.icon-minus');
        const isActive = $heading.hasClass('active');

        // Reset all
        $('.footer-block__heading').removeClass('active');
        $('.footer-according').slideUp(200);
        $('.maryn-footer-section .icon-plus').removeClass('hidden');
        $('.maryn-footer-section .icon-minus').addClass('hidden');

        // Open clicked one
        if (!isActive) {
          $heading.addClass('active');
          $details.stop().slideDown(200);
          $plusIcon.addClass('hidden');
          $minusIcon.removeClass('hidden');
        }
      });

    } else {
      // Desktop: always show sections, reset icons
      $('.footer-according').show();
      $('.footer-block__heading').removeClass('active').off('click.footerAccordion');
      $('.maryn-footer-section .icon-plus').addClass('hidden');
      $('.maryn-footer-section .icon-minus').removeClass('hidden');
    }
  }

  // Initial setup
  setFooterState();

  // Handle window resize
  $(window).on('resize', function () {
    setFooterState();
  });
});
